(() => {
  const config = window.DecorwellDevHome;
  if (!config || !config.cushionCollectionUrl || !config.cushionCollectionImage) return;

  const injectCushionCollection = (root = document) => {
    const section = root.matches?.('.statement-staples')
      ? root
      : root.querySelector?.('.statement-staples');

    if (!section || section.querySelector('.decorwell-cushion-collection-slide')) return;

    const wrapper = section.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    const slides = Array.from(wrapper.children).filter((child) =>
      child.classList.contains('swiper-slide') && !child.classList.contains('swiper-slide-duplicate')
    );
    if (slides.length < 2) return;

    const slide = document.createElement('div');
    slide.className = 'swiper-slide decorwell-cushion-collection-slide';

    const card = document.createElement('a');
    card.className = 'ss-card';
    card.href = config.cushionCollectionUrl;
    card.setAttribute('aria-label', config.cushionCollectionTitle || 'Cushions');

    const imageBox = document.createElement('div');
    imageBox.className = 'ss-image-box';

    const image = document.createElement('img');
    image.src = config.cushionCollectionImage;
    image.alt = config.cushionCollectionAlt || 'Cushions';
    image.loading = 'lazy';
    image.decoding = 'async';
    image.style.objectPosition = 'center center';
    imageBox.appendChild(image);

    const info = document.createElement('div');
    info.className = 'ss-info';

    const title = document.createElement('span');
    title.className = 'ss-title';
    title.textContent = config.cushionCollectionTitle || 'CUSHIONS';

    const arrow = document.createElement('span');
    arrow.className = 'ss-card-arrow';
    arrow.textContent = '→';

    info.append(title, arrow);
    card.append(imageBox, info);
    slide.appendChild(card);
    slides[1].insertAdjacentElement('afterend', slide);

    const swiperElement = section.querySelector('.swiper');
    const updateSwiper = () => swiperElement?.swiper?.update();
    updateSwiper();
    requestAnimationFrame(updateSwiper);
    setTimeout(updateSwiper, 120);
  };

  const init = () => {
    document.querySelectorAll('.statement-staples').forEach((section) => injectCushionCollection(section));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const sectionRoot = document.getElementById(`shopify-section-${event.detail.sectionId}`) || event.target;
    injectCushionCollection(sectionRoot);
  });
})();